export const ModelsCarsDto = (entranceModelsCarsdto) => ({
    count: entranceModelsCarsdto.contagem
});
export const TableModelDataDtoToTableDataItem = (tableModelData) => tableModelData.map(dto => ({
    plate: dto.placa,
    brand: dto.marca,
    model: dto.modelo,
    yearModel: dto.anoModelo,
    yearFabrication: dto.anoFabricacao,
    color: dto.cor,
    region: dto.regiao,
    km: dto.kmAtual,
}));
export const TableModelDataDtoToTableModelData = (tableModelData) => ({
    itens: TableModelDataDtoToTableDataItem(tableModelData.listagem),
    pageCount: tableModelData.totalPaginas,
    rows: tableModelData.totalRegistros,
});
